var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main_title"},[_c('el-image',{attrs:{"src":_vm.requireImage(_vm.image)}}),_vm._v(" "),_c('div',{staticClass:"yinying"}),_vm._v(" "),_c('div',{staticClass:"item"},[_c('div',[_vm._v(_vm._s(_vm.$store.state.headerTitle))]),_vm._v(" "),_c('div',{staticClass:"item-text"},[_vm._v(_vm._s(_vm.$store.state.headerText))])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ff74e12","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/header/title.vue
// module id = null
// module chunks = 